import * as vx3Plugin from './vx3-extra.min'

export default vx3Plugin;


// WEBPACK FOOTER //
// ./src/plugins/vx3Plugin/index.js